import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ErrorInterceptor implements HttpInterceptor {

  responsehtt: any;
  constructor(
    private messageService: MessageService,
    private router: Router
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap(evt => {
        if (evt instanceof HttpResponse) {
          if (evt.body.errors) {
            evt.body.errors.forEach(element => {
              this.messageService.add({
                key: 'notification',
                severity: 'error',
                summary: 'ADVERTENCIA',
                detail: element.description,
              });
            });
          }
        }
      }),
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse) {
          try {
          } catch (e) {
          }
          this.messageService.add({
            key: 'notification',
            severity: 'error',
            summary: 'Advertencia',
            detail: err.error.error_description,
          });
          // log error
        }
        return of(err);
      }));
  }

  // return next.handle(req).pipe(map((event: HttpEvent<any>) => {
  //   if (event instanceof HttpResponse) {
  //     console.log("PAPA", event.body.errors[0]);
  //     this.messageService.add({
  //       severity: 'error',
  //       summary: "hola",
  //       detail: event.body.title,
  //     });

  //   }
  //   return event;
  // }));

  // }

  // public intercept(httpRequest: HttpRequest<any>, next: HttpHandler) : Observable<HttpEvent<any>> {
  //   if (httpRequest.method !== 'POST')
  //     return next.handle(httpRequest);
  //   else {
  //     this.responsehtt = HttpRequest;
  //     let reponserr = HttpResponse;

  //     console.log(reponserr);

  //     this.messageService.add({
  //       key: 'notification',
  //       severity: 'error',
  //       summary: 'Woops! There was an error!',
  //     });
  //     return next.handle(httpRequest).pipe(
  //       catchError( (err: HttpErrorResponse) => {
  //         console.log(err)

  //         return throwError(err);
  //       })
  //     );
  //   }

  // }
}
